import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withRouter} from "react-router";
import {connect} from "trim-redux";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import Typography from "@material-ui/core/Typography/Typography";
import Countdown from 'react-countdown';
import TrackingProgress from "./components/progress/TrackingProgress";
import Title from "../../components/elements/Title";
import clsx from "clsx";
import Logo from '../../../files/img/logo-w.png';
import Box from "@material-ui/core/Box/Box";
import {Link} from "react-router-dom";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ShoppingBasketRoundedIcon from '@material-ui/icons/ShoppingBasketRounded';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import AirplanemodeActiveRoundedIcon from '@material-ui/icons/AirplanemodeActiveRounded';
import DirectionsBoatRoundedIcon from '@material-ui/icons/DirectionsBoatRounded';
import AvTimerRoundedIcon from '@material-ui/icons/AvTimerRounded';
import Copyright from "../../components/elements/Copyright";
import Loader from "../../components/elements/Loader";
import HourglassFullRoundedIcon from '@material-ui/icons/HourglassFullRounded';
import Button from "@material-ui/core/Button/Button";
import MainSearch from "./components/MainSearch";
import UserInfo from "../../components/layouts/components/UserInfo";
class HomePage extends React.Component {

    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.orderTracking} >
                <Grid container justify="center" alignItems="center"  className={this.classes.trackPage}>
                    <Grid item xs={12}>
                        <div className={clsx('hero-header', this.classes.heroHeader)}>
                            <Box
                                component="a"
                                href={defaultVariabls.mainSite}
                                style={{
                                    cursor: "pointer",
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'center',
                                }}>
                                <img
                                    style={{height:45,margin:15}}
                                    src={Logo}
                                    alt={Translate.appName}
                                    title={Translate.appName}
                                />
                            </Box>
                            <Title>{Translate.orderTracking}</Title>
                            <div className="rechts1"></div>
                            <div className="rechts2"></div>
                        </div>
                    </Grid>
                    <Grid item xs={11}>
                        <Grid container spacing={2} justify="center" alignItems="center" >
                            <Grid item xs={12} md={11} lg={9}>
                                <Grid container spacing={2} justify="center" alignItems="stretch" style={{margin:"75px 0 50px"}}>
                                    <Grid item xs={12} md={6}>
                                        <AppCard
                                            className="track-app-card home"
                                            style={{height:"100%",}}
                                            title={Translate.checkOrderStatus}
                                        >
                                            <Typography>{Translate.pasteYourTrackingCode}</Typography>
                                            <MainSearch/>
                                        </AppCard>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className="text-center mt-15">
                                <Button
                                    component="a"
                                    href={defaultVariabls.mainSite}
                                    target="_blank"
                                    color="primary"
                                    variant="contained"
                                    size="large"
                                >
                                    {Translate.goBackToDarkoob}
                                </Button>
                                {
                                    this.props.isAuth ? <Button
                                            style={{margin: "0 10px"}}
                                            component={Link}
                                            to="/dashboard"
                                            variant="outlined"
                                            color="primary"
                                        >
                                            {Translate.adminPanel}
                                        </Button> :
                                        <Button
                                            style={{margin: "0 10px"}}
                                            component={Link}
                                            to="/login"
                                            variant="outlined"
                                            color="primary"
                                        >
                                            {Translate.login}
                                        </Button>
                                }

                            </Grid>
                            <Grid item xs={12}>
                                <Copyright/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(HomePage)))));